import { createApp } from "vue"
import { IonicVue } from '@ionic/vue'

import App from './App.vue'
import store from "./store"
import router from "./router"

import "./assets/css/nucleo-icons.css"
import "./assets/css/nucleo-svg.css"
import "./assets/css/easy.css"

import ArgonDashboard from "./argon-dashboard"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faGoogle } from "@fortawesome/free-brands-svg-icons"

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

async function bootstrap() {
  const app = createApp(App)

  app
    .component("FontAwesomeIcon", FontAwesomeIcon)
    .use(store)
    .use(IonicVue)
    .use(router)
    .use(Toast)
    .use(ArgonDashboard)

  app.config.globalProperties.$app_name = 'JS Logística'

  // 🔹 carrega config.json
  try {
    const res = await fetch('/config.json')
    app.config.globalProperties.$config = await res.json()
  } catch (err) {
    console.error('Erro ao carregar config.json', err)
    app.config.globalProperties.$config = {}
  }

  // 🔹 espera router
  await router.isReady()

  // 🔥 mount único
  app.mount('#app')
}

bootstrap()
